import ky from 'ky'
import type { ResRefresh } from '@/shared/types'
import {
  clearAuthTokens,
  getRefreshToken,
  setAuthTokens,
} from '@/shared/lib/auth-tokens'

let refreshTokensPromise: Promise<ResRefresh> | null = null

export async function refreshAuthTokens(): Promise<ResRefresh> {
  if (!refreshTokensPromise) {
    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      clearAuthTokens()
      throw new Error('Refresh token is missing')
    }

    refreshTokensPromise = ky
      .post('auth/refresh', {
        prefixUrl: '/api/',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${refreshToken}`,
        },
        retry: 0,
      })
      .json<ResRefresh>()
      .then((data) => {
        setAuthTokens(data.accessToken, data.refreshToken)
        return data
      })
      .catch((error) => {
        clearAuthTokens()
        throw error
      })
      .finally(() => {
        refreshTokensPromise = null
      })
  }

  return refreshTokensPromise
}
